import { render, staticRenderFns } from "./FattorinoStats.vue?vue&type=template&id=5beec84a&"
import script from "./FattorinoStats.vue?vue&type=script&lang=ts&"
export * from "./FattorinoStats.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports